import { Component, OnInit, inject } from '@angular/core';
import { DivePlannerService } from '../dive-planner-service/DivePlannerService';
import * as Plotly from 'plotly.js-basic-dist-min';
import { MatDialog } from '@angular/material/dialog';
import { GraphDialogComponent } from '../graph-dialog/graph-dialog.component';

@Component({
  selector: 'dive-tissues-pn2-chart',
  templateUrl: './tissues-pn2-chart.component.html',
  styleUrl: './tissues-pn2-chart.component.scss',
})
export class TissuesPN2ChartComponent implements OnInit {
  divePlanner = inject(DivePlannerService);
  dialog = inject(MatDialog);

  private readonly ERROR_COLOR = 'red';
  private readonly WARNING_COLOR = 'orange';
  private readonly PRIMARY_COLOR = '#3F51B5';

  ngOnInit(): void {
    Plotly.newPlot('tissues-pn2-chart', this.getTissuesPN2ChartData(), this.getTissuesPN2ChartLayout(), this.getChartOptions());
  }

  onTissuesPN2ChartClick(): void {
    if (this.getShowGraphs()) {
      this.dialog.open(GraphDialogComponent, {
        data: { trace: this.getTissuesPN2ChartData(), layout: this.getTissuesPN2ChartLayout(), options: this.getChartOptions() },
        height: '80%',
        width: '80%',
      });
    }
  }

  getShowGraphs(): boolean {
    return this.divePlanner.getDiveSegments().length > 2;
  }

  getGraphClass(): string {
    return this.getShowGraphs() ? '' : 'hidden';
  }

  private chartData: Plotly.Data[] | null = null;

  private getTissuesPN2ChartData(): Plotly.Data[] {
    if (!this.chartData) {
      const ceilingData = this.divePlanner.getTissuesPN2ChartData();
      const x = ceilingData.map(d => new Date(1970, 1, 1, 0, 0, d.time, 0));

      const tissueTraces: Plotly.Data[] = [];

      for (let i = 1; i <= 16; i++) {
        tissueTraces.push({
          x,
          y: ceilingData.map(d => d.tissuesPN2[i - 1]),
          type: 'scatter',
          mode: 'lines',
          name: `Tissue ${i} PN2`,
          line: {
            width: 2,
          },
          hovertemplate: `%{y:.2f}`,
        });
      }

      this.chartData = [
        {
          x,
          y: ceilingData.map(d => d.gasPN2),
          type: 'scatter',
          mode: 'lines',
          name: 'Gas PN2',
          line: {
            color: this.PRIMARY_COLOR,
            width: 5,
          },
          hovertemplate: `%{y:.2f}`,
        },
        ...tissueTraces,
      ];
    }

    return this.chartData;
  }

  private getTissuesPN2ChartLayout(): Partial<Plotly.Layout> {
    return {
      autosize: true,
      showlegend: false,
      title: {
        text: 'Tissues PN<sub>2</sub> vs Gas PN<sub>2</sub>',
        y: 0.98,
      },
      margin: { l: 35, r: 10, b: 30, t: 20, pad: 10 },
      xaxis: {
        fixedrange: true,
        tickformat: '%H:%M:%S',
      },
      yaxis: {
        fixedrange: true,
        rangemode: 'tozero',
        zeroline: false,
      },
      hovermode: 'x unified',
      hoverlabel: {
        bgcolor: 'rgba(200, 200, 200, 0.4)',
        bordercolor: 'rgba(200, 200, 200, 0.4)',
      },
    };
  }

  private getChartOptions(): Partial<Plotly.Config> {
    return {
      responsive: true,
      displaylogo: false,
      displayModeBar: false,
      autosizable: true,
      scrollZoom: false,
      editable: false,
    };
  }
}
